/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Ref_N2Inputs */

const en_to_yaml_ref_n2 = /** @type {(inputs: To_Yaml_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quoted for the same reason. Unquoted yes reads as true in YAML 1.1.`)
};

const ko_to_yaml_ref_n2 = /** @type {(inputs: To_Yaml_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`같은 이유로 인용됩니다. 인용하지 않은 yes는 YAML 1.1에서 true로 읽힙니다.`)
};

const ja_to_yaml_ref_n2 = /** @type {(inputs: To_Yaml_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同じ理由で引用されます。引用のない yes は YAML 1.1 で true として読まれます。`)
};

/**
* | output |
* | --- |
* | "Quoted for the same reason. Unquoted yes reads as true in YAML 1.1." |
*
* @param {To_Yaml_Ref_N2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_ref_n2 = /** @type {((inputs?: To_Yaml_Ref_N2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Ref_N2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_ref_n2(inputs)
	if (locale === "ko") return ko_to_yaml_ref_n2(inputs)
	return ja_to_yaml_ref_n2(inputs)
});